import { render, staticRenderFns } from "./blocked-ui.html?vue&type=template&id=071dd239&scoped=true&external"
import script from "./blocked-ui.js?vue&type=script&lang=js&external"
export * from "./blocked-ui.js?vue&type=script&lang=js&external"
import style0 from "./blocked-ui.scss?vue&type=style&index=0&id=071dd239&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071dd239",
  null
  
)

export default component.exports